import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { IncomingEmailList } from "@msuite/utils/types";
import { client } from "@/hono";

export function useMailboxEmails(mailboxId: string) {
	/** Query */
	const query = useQuery({
		queryKey: ["mailboxes", "emails", mailboxId],
		queryFn: async () => {
			const response = await client.mailboxes[":mailboxId"].emails.$get({
				param: { mailboxId },
			});
			const data = await responseHandler(response);
			return data.emails as IncomingEmailList;
		},
	});

	/** Return */
	return { ...query, emails: query.data ?? [] };
}
